import React, { useState } from "react";
// import EmailForm from "../EmailForm/EmailForm";
import "./Start.css";

function Start(props) {
  const [emailFormState, setEmailFormState] = useState(true);
  const timeout = ms => new Promise(res => setTimeout(res, ms))
  let appElm;
  let bracketElm;

  let smoothScrollTo = (toX, toY) => {
    // console.log('animate to', toX, toY);
    let element = appElm;
    let duration = 500;

    let startY = element.scrollTop,
      changeY = toY - startY,
      currentTimeY = 0,
      incrementY = 20;
    let startX = element.scrollLeft,
      changeX = toX - startX,
      currentTimeX = 0,
      incrementX = 20;

    let animateScrollY = function () {
      currentTimeY += incrementY;
      let val = Math.easeInOutQuad(currentTimeY, startY, changeY, duration);
      element.scrollTop = val;
      if (currentTimeY < duration) {
        setTimeout(animateScrollY, incrementY);
      }
    };
    animateScrollY();

    let animateScrollX = function () {
      currentTimeX += incrementX;
      let val = Math.easeInOutQuad(currentTimeX, startX, changeX, duration);
      element.scrollLeft = val;
      if (currentTimeX < duration) {
        setTimeout(animateScrollX, incrementX);
      }
    };
    animateScrollX();
  }

  //t = current time
  //b = start value
  //c = change in value
  //d = duration
  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  let cardClickHandler = async mode => {
    // try {
    //   document.querySelector("#App").requestFullscreen();
    // } catch(e){}

    window.gaTrackAction = `Game Mode ${mode}`;
    window.trackEvent(`Start Game Mode ${mode}`);
    window.winnerAlreadyTracked = false;

    //manages loading screen
    //want to eventually use event listeners for the animations instead of timing
    props.displayAnimationContainer(true);
    await timeout(2000);
    props.selectGameMode('play', mode);
    
    appElm = document.querySelector("#App");
    bracketElm = document.querySelector("#bracket");

    appElm.scrollLeft = 0;
    appElm.scrollTop = 0;
    
    await timeout(2900);
    props.displayAnimationContainer(false);

    if (bracketElm.offsetWidth > window.innerWidth || bracketElm.offsetHeight > window.innerHeight) {
      setTimeout(() => {
        // scroll to right top
        smoothScrollTo(bracketElm.offsetWidth, 0);
        // scroll to right bottom
        setTimeout(() => {
          smoothScrollTo(bracketElm.offsetWidth, bracketElm.offsetHeight);
          // scroll to left bottom
          setTimeout(() => {
            smoothScrollTo(0, bracketElm.offsetHeight);
            // scroll to left top
            setTimeout(() => {
              smoothScrollTo(0, 0);
            }, 1000);
          }, 1000);
        }, 1000);
      }, 1000);
    }
  }

  let hideEmailForm = (event) => {
    event.preventDefault()
    setEmailFormState(false)
  }

  let showEmailForm = (state) => {
    if(state){
      // return <EmailForm hideEmailForm={hideEmailForm}/>
    }
    else {
      return "";
    }
    
  }

  return (
    <div id="Start">
      {showEmailForm(emailFormState)}
      <img src={"https://bin.complex.com/websites/rap-brackets/img/complex-brackets-logo-main.jpg"} className="start_cards_logo" />
      <div className="start_header_subtext">PLAY NOW TO CROWN YOUR WINNER</div>
      <div className="card_container">
        <img src={"https://bin.complex.com/websites/rap-brackets/img/start-top100.jpg"} className="start_card start_card1 animated pulse" onClick={() => { cardClickHandler("top100"); }} />
        <img src={"https://bin.complex.com/websites/rap-brackets/img/start-westcoast.jpg"} className="start_card start_card2 animated pulse" onClick={() => { cardClickHandler("west"); }} />
        <img src={"https://bin.complex.com/websites/rap-brackets/img/start-eastcoast.jpg"} className="start_card start_card3 animated pulse" onClick={() => { cardClickHandler("east"); }} />
        <img src={"https://bin.complex.com/websites/rap-brackets/img/start-dirtysouth.jpg"} className="start_card start_card4 animated pulse" onClick={() => { cardClickHandler("dirtySouth"); }} />
        <img src={"https://bin.complex.com/websites/rap-brackets/img/start-bestdecade.jpg"} className="start_card start_card4 animated pulse" onClick={() => { cardClickHandler("2010"); }} />
      </div>
      {/* <p className="start_marquee" scrollamount="12"><span>A NEW INTERACTIVE GAME SHOW FROM COMPLEX NEWS<strong>YOU CROWN THE RAP CHAMP</strong>COMING SOON</span></p> */}
    </div>
  );
}
export default Start;
